import React, { useCallback, useEffect, useState } from 'react'
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from 'primereact/dialog'
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import CustomToast from '../../Components/CustomToast';


export const ProductWatchers = (props) => {
    const { t } = useTranslation("common");
    const { viewWatcherPopup, hideWatcherPopup, product } = props;

    //local states
    const [watcherEmail, setWatcherEmail] = useState('')
    const [toastTrigger, setToastTrigger] = useState(false);
    const [toastData, setToastData] = useState({
        summary: '',
        severity: '',
        detail: '',
        life: 0
    });
    const [state, setState] = useState({
        emailsWatchingProduct: null,
        addClicked: false,
        removeClicked: false,
        error: ''
    })

    //redux states
    const { errorAddingWatcher, addingWatcher, watcher, errorRemovingWatcher, productWatcher,
        removeWatcher, fetchingProductWatcher, removingWatcher
    } = useSelector((state) => state.planGroups);

    //redux calls
    const dispatch = useDispatch();
    const addWatcher = useCallback((watcher) => { dispatch(PlanGroupActions.addWatcherRequest(watcher)) }, [dispatch])
    const removeProductWatcher = useCallback((watcherId) => { dispatch(PlanGroupActions.removeWatcherRequest(watcherId)) }, [dispatch])
    const getProductWatcher = useCallback((planGroupId) => { dispatch(PlanGroupActions.getProductWatcherRequest(planGroupId)) }, [dispatch])
    const getProductWatcherCount = useCallback((planGroupId) => { dispatch(PlanGroupActions.getProductWatcherCountRequest(planGroupId)) }, [dispatch])

    const showToast = (summary, severity, detail, life = 3000) => {
        setToastData({ severity, summary, detail, life });
        setToastTrigger(true)
    }

    useEffect(() => {
        if (product && product.id) {
            getProductWatcher(product.id)
            getProductWatcherCount(product.id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product])

    useEffect(() => {
        if (productWatcher) {
            setState((prev) => ({ ...prev, emailsWatchingProduct: productWatcher }))
        }
    }, [productWatcher])

    useEffect(() => {
        if (!addingWatcher && watcher && state.addClicked) {
            showToast(t("success"), "success", t("products.watcher_added"))
        }
        if (!removingWatcher && state.removeClicked) {
            showToast(t("success"), "success", t("products.watcher_removed"))
        }
        if (!addingWatcher && errorAddingWatcher && state.addClicked) {
            showToast(t("err"), "error", t("products.failure_add"), 5000)
        }
        if (!removingWatcher && errorRemovingWatcher && state.removeClicked) {
            showToast(t("err"), "error", t("products.failure_remove"), 5000)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.addClicked, state.removeClicked, errorAddingWatcher, watcher,
        addingWatcher, errorRemovingWatcher, removingWatcher, removeWatcher])

    const emails = state.emailsWatchingProduct?.flatMap((item) => [{ name: item.email, key: item.id }])

    const [selectedEmails, setSelectedEmails] = useState([emails && emails]);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const onCheckChange = (e) => {
        let chosenEmails = [selectedEmails];
        if (e.checked)
            chosenEmails.push(e.value);
        else
            chosenEmails = chosenEmails.filter(category => category.key !== e.value.key);

        setSelectedEmails(chosenEmails);
    };

    function handleAddClick() {
        if (!(watcherEmail && product?.id)) return

        if (!emailRegex.test(watcherEmail)) {
            setState(prev => ({ ...prev, error: t("products.invalid_email") }))
            return;
        }
        if (state.emailsWatchingProduct?.some(w => w.email === watcherEmail)) {
            setState(prev => ({ ...prev, error: t("products.email_exists") }))
            return;
        }

        setState(prev => ({ ...prev, addClicked: true }))

        const watcher = {
            email: watcherEmail,
            planGroupId: product?.id
        }
        addWatcher(watcher)
    }

    const emailSelected = selectedEmails && selectedEmails[1];

    const handleRemoveClick = function () {
        if (!emailSelected) return;
        setState(prev => ({ ...prev, removeClicked: true }))
        const watcherId = selectedEmails[1].key;
        removeProductWatcher(watcherId);
    }

    const loadConditions = fetchingProductWatcher
    const disableAddConditions = !watcherEmail || !product?.id || emailSelected || state.addClicked
    const disableRemoveConditions = removingWatcher || !emailSelected || state.removeClicked

    const watcherOnChange = (e) => {
        const value = e?.target.value;
        setState(prev => ({ ...prev, error: '' }))
        setState(prev => ({ ...prev, addClicked: false }))

        setWatcherEmail(value)
    }

    const onHide = () => {
        hideWatcherPopup()
        setState(prev => ({ ...prev, error: '' }))
        setWatcherEmail('')
    }

    return (
        <div>
            <CustomToast
                {...toastData}
                trigger={toastTrigger}
                handleActionsAfterToast={() => {
                    setToastTrigger(false)
                    setState(prev => ({ ...prev, addClicked: false }))
                    setState(prev => ({ ...prev, removeClicked: false }))
                    setWatcherEmail('')
                    setState(prev => ({ ...prev, error: '' }))
                    setSelectedEmails([])
                    getProductWatcher(product.id)
                }}
                handleActionsAfterErrorToast={() => { }}
            />
            <Dialog
                header={t("products.add_product_watcher")}
                visible={viewWatcherPopup}
                onHide={onHide}
                style={{ width: "350px", height: "auto" }}
            >
                <main>
                    <div className='p-3'>
                        <label className='label font-xs'>{t("products.watcher_email")}</label>
                        <section className='flex gap-2'>
                            <InputText
                                className={state.error && "invalid-input"}
                                placeholder={t("products.enter_email")}
                                style={{ height: "3rem", width: "80%" }}
                                value={watcherEmail}
                                disabled={emailSelected}
                                onChange={(e) => watcherOnChange(e)}
                            />
                            <Button className={disableAddConditions ? 'product_watcher_add_button_disabled' : 'product_watcher_add_button'}
                                onClick={handleAddClick}
                                loading={addingWatcher}
                                disabled={disableAddConditions}
                            >{t("products.add")}</Button>
                        </section>
                        {state.error && <span className='mt-2 p-error error_phone_required'>{state.error}</span>}

                    </div>

                    <hr className="first_hr_business" />

                    {loadConditions ? <div className='flex align-items-center'>
                        <ProgressSpinner
                            style={{ width: '35px', height: '35px', color: 'whitesmoke', marginTop: '0.3rem' }}
                            animationDuration=".8s" />
                    </div>
                        : !emails?.length ?
                            <p className='px-4 pt-2'>{t("products.no_watchers")}</p>
                            : <section className='p-3'>
                                {emails?.map((person) => {
                                    return <div key={person.id} className='flex gap-3 pb-2'>
                                        <Checkbox
                                            value={person}
                                            onChange={onCheckChange} checked={selectedEmails?.some((item) => item?.key === person?.key)}
                                            name='email'
                                            inputId={person?.id}
                                        >
                                        </Checkbox>
                                        <label htmlFor={person?.key} className="ml-2">
                                            {person?.name}
                                        </label>
                                    </div>
                                })}
                            </section>}

                    <div className='flex justify-content-end align-items-center px-3 pb-3 remove_box'>
                        <Button className={disableRemoveConditions ? 'product_watcher_remove_button_disable' : 'product_watcher_remove_button'}
                            loading={removingWatcher}
                            disabled={disableRemoveConditions}
                            onClick={handleRemoveClick}
                        >{t("products.remove")}</Button>
                    </div>
                </main>
            </Dialog>

        </div>
    )
}
